import apiClient from './apiClient';

export async function listClassifications(filters = {}) {
  const res = await apiClient.get('/classification', { params: filters });
  return res.data.data.items;
}
export async function getMatrix() {
  const res = await apiClient.get('/classification/matrix');
  return res.data.data.items;
}
export async function refreshClassifications() {
  const res = await apiClient.post('/classification/refresh');
  return res.data.data;
}
